import { render, staticRenderFns } from "./AuthXWidget.vue?vue&type=template&id=3f56bfe1"
import script from "./AuthXWidget.vue?vue&type=script&lang=js"
export * from "./AuthXWidget.vue?vue&type=script&lang=js"
import style0 from "./AuthXWidget.vue?vue&type=style&index=0&id=3f56bfe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports